export default {"src":"/_next/static/media/large_filled.dbd70a2c.svg","height":24,"width":24};